import gql from "graphql-tag";

export const COMMON_PROPS_REFERENCES = `
  id
  title
  url
  creationDate { formatted }
  lastModifiedDate { formatted }
  file {
    id,
    uri,
    fileName,
    mimeType,
    fileType,
    size,
    bitDepth,
    samplingRate
  }
  __typename
`;

export const COMMON_PROPS_REFERENCES_COMMENTS = `
  comments {
    id
    text
    creationDate {
      formatted
    }
    lastModifiedDate {
      formatted
    }
    author {
      id
      accountId
      authStatus
      fullName
      imageDepictions {
        id
        title
        type
        thumbnail {
          id
          file {
            uri
          }
        }
      }
      __typename
    }
  }
`;

export const COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS = `
  isContributionOf {
    id
    role
    isArchived
    contributor {
      id
      accountId
      __typename
    }
  }
`;

export const CREATE_REFERENCE = gql`
mutation CreateReference (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $fullFileKey: String
) {
  CreateReference(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    fullFileKey: $fullFileKey
  ) 
  {
    ${COMMON_PROPS_REFERENCES}
    ${COMMON_PROPS_REFERENCES_COMMENTS}
    ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
  }
}
`;

export const CREATE_VERSION_OF_REFERENCE = gql`
mutation CreateVersionOfReference(
  $partyId: ID!,
  $projectId: ID,
  $label: String!,
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $parentComponentId: ID!
  $fullFileKey: String
  )
{
  CreateVersionOfReference(
    partyId: $partyId,
    projectId: $projectId,
    label: $label,
    componentInput: $componentInput,
    fileInput: $fileInput,
    parentComponentId: $parentComponentId
    fullFileKey: $fullFileKey
    )
  {
    ${COMMON_PROPS_REFERENCES}
    ${COMMON_PROPS_REFERENCES_COMMENTS}
    ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
  }
}
`;

export const CREATE_REFERENCE_WITH_WORK = gql`
mutation CreateReferenceWithWork (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $fullFileKey: String
) {
  CreateReferenceWithWork(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    fullFileKey: $fullFileKey
  ) 
  {
    ${COMMON_PROPS_REFERENCES}
    ${COMMON_PROPS_REFERENCES_COMMENTS}
    ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
  }
}
`;

export const CREATE_VERSION_OF_REFERENCE_WITH_WORK = gql`
mutation CreateVersionOfReferenceWithWork (
  $partyId: ID!,
  $projectId: ID,
  $label: String!
  $componentInput: ComponentInput, 
  $fileInput: FileInput,
  $parentComponentId: ID!
  $latestVersionComponentId: ID!
  $workId: ID!
  $fullFileKey: String
) {
  CreateVersionOfReferenceWithWork(
    partyId: $partyId,
    projectId: $projectId,
    label: $label
    componentInput: $componentInput,
    fileInput: $fileInput
    parentComponentId: $parentComponentId
    latestVersionComponentId: $latestVersionComponentId
    workId: $workId
    fullFileKey: $fullFileKey
  ) 
  {
    ${COMMON_PROPS_REFERENCES}
    ${COMMON_PROPS_REFERENCES_COMMENTS}
    ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
  }
}
`;

export const GET_IMAGE_REFERENCE = gql`
  query getImage(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Image(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      ${COMMON_PROPS_REFERENCES}
      ${COMMON_PROPS_REFERENCES_COMMENTS}
      ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
    }
  }
`;

export const GET_SOURCE_FILE_REFERENCE = gql`
  query SourceFile(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    SourceFile(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      ${COMMON_PROPS_REFERENCES}
      ${COMMON_PROPS_REFERENCES_COMMENTS}
      ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
    }
  }
`;

export const GET_TEXT_REFERENCE = gql`
  query Text(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Text(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      ${COMMON_PROPS_REFERENCES}
      ${COMMON_PROPS_REFERENCES_COMMENTS}
      ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
    }
  }
`;

export const GET_VIDEO_REFERENCE = gql`
  query Video(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Video(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      ${COMMON_PROPS_REFERENCES}
      ${COMMON_PROPS_REFERENCES_COMMENTS}
      ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
    }
  }
`;

export const GET_RECORDING_REFERENCE = gql`
  query Recording(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Recording(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      ${COMMON_PROPS_REFERENCES}
      ${COMMON_PROPS_REFERENCES_COMMENTS}
      ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
    }
  }
`;